// Root getters
export default {
  latestLocation: state => {
    return state.latest
  },
  latestETA: state => {
    return state.eta
  },
  latestDirections: state => {
    return state.directions
  }
}
